import css from './LanguageSelector.module.scss'
import React from 'react'
import Skeleton from 'react-loading-skeleton'

import { Breakpoints } from 'meta/layout/breakpoints'
import { TICKETSMS_COLORS_LIGHTGREY, TICKETSMS_COLORS_WHITE } from 'utils/constants/colors'

import { GridColumn } from 'components/Layout/Grid'

export const LanguageSelectorSkeleton: React.FC = () => {
  return (
    <GridColumn
      gridColumnStart={{ [Breakpoints.mobile]: 10, [Breakpoints.tablet]: 14, [Breakpoints.laptop]: 14 }}
      gridColumnEnd={{ [Breakpoints.mobile]: 13, [Breakpoints.tablet]: 17, [Breakpoints.laptop]: 17 }}
      className={css.languageSelector}
    >
      <Skeleton
        className={css.btnSkeleton}
        baseColor={TICKETSMS_COLORS_WHITE}
        borderRadius={16}
        highlightColor={TICKETSMS_COLORS_LIGHTGREY}
      />
    </GridColumn>
  )
}
